/* eslint-disable prefer-const */
/* eslint-disable radix */
/* eslint-disable camelcase */
const convertMillisecToTime = (miliseconds, format) => {
  if (!miliseconds) return '';

  let days;
  let hours;
  let minutes;
  let seconds;
  let total_hours;
  let total_minutes;
  let total_seconds;

  total_seconds = parseInt(Math.floor(miliseconds / 1000));
  total_minutes = parseInt(Math.floor(total_seconds / 60));
  total_hours = parseInt(Math.floor(total_minutes / 60));
  days = parseInt(Math.floor(total_hours / 24));

  seconds = parseInt(total_seconds % 60);
  minutes = parseInt(total_minutes % 60);
  hours = parseInt(total_hours % 24);

  switch (format) {
    case 's':
      return total_seconds;
    case 'm':
      return total_minutes;
    case 'h':
      return total_hours;
    case 'd':
      return days;
    default:
      return `${days}days:${hours}hr:${minutes}min:${seconds}s`;
  }
};
export default convertMillisecToTime;
